/**
 * Printem VAT display toggle (storefront display-only).
 * Preference: localStorage printem_vat_mode = 'ex' | 'inc'
 * Rate: UK 20% (×1.2). Checkout still follows Shopify tax settings.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'printem_vat_mode';
  var RATE = 1.2;
  var DEFAULT_MODE = 'ex';

  function getMode() {
    try {
      var m = localStorage.getItem(STORAGE_KEY);
      if (m === 'ex' || m === 'inc') return m;
    } catch (e) {}
    return DEFAULT_MODE;
  }

  function setMode(mode) {
    if (mode !== 'ex' && mode !== 'inc') mode = DEFAULT_MODE;
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {}
    document.documentElement.setAttribute('data-printem-vat', mode);
    window.PrintemVat.mode = mode;
    applyAll();
    syncControls();
    try {
      document.dispatchEvent(
        new CustomEvent('printem:vat-change', { detail: { mode: mode } })
      );
    } catch (e2) {}
  }

  function formatGbpFromCents(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '—';
    var pounds = n / 100;
    return (
      '£' +
      pounds.toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
  }

  function displayCents(exCents, mode) {
    var n = Number(exCents);
    if (!isFinite(n)) return null;
    if (mode === 'inc') return Math.round(n * RATE);
    return Math.round(n);
  }

  function labelFor(mode) {
    return mode === 'inc' ? 'inc VAT' : 'ex VAT';
  }

  function applyElement(el, mode) {
    if (!el) return;
    var raw = el.getAttribute('data-ex-vat-cents');
    if (raw == null || raw === '') return;
    var shown = displayCents(raw, mode);
    if (shown == null) return;
    var txt = formatGbpFromCents(shown);
    if (el.textContent !== txt) el.textContent = txt;
  }

  function applyLabels(mode) {
    document.querySelectorAll('[data-printem-vat-label]').forEach(function (el) {
      if (el.textContent !== labelFor(mode)) el.textContent = labelFor(mode);
    });
    document.querySelectorAll('[data-printem-vat-aria]').forEach(function (el) {
      var base = el.getAttribute('data-printem-vat-aria') || '';
      el.setAttribute('aria-label', base + ', ' + labelFor(mode));
    });
    function setText(el, txt) {
      if (el.textContent !== txt) el.textContent = txt;
    }
    document.querySelectorAll('[data-printem-vat-title]').forEach(function (el) {
      var base = el.getAttribute('data-printem-vat-title') || '';
      if (base.indexOf('(ex VAT)') !== -1 || base.indexOf('(inc VAT)') !== -1) {
        setText(el, base.replace(/\(ex VAT\)|\(inc VAT\)/gi, '(' + labelFor(mode) + ')'));
      } else {
        /* titles that embed "ex VAT" without parens (or none at all) */
        setText(
          el,
          base.replace(/\bex VAT\b/gi, labelFor(mode)).replace(/\binc VAT\b/gi, labelFor(mode))
        );
      }
    });
    document.querySelectorAll('[data-printem-tax-note]').forEach(function (el) {
      if (!el.getAttribute('data-printem-tax-note')) {
        el.setAttribute('data-printem-tax-note', el.textContent || '');
      }
      var base = el.getAttribute('data-printem-tax-note');
      setText(
        el,
        base.replace(/\bex VAT\b/gi, labelFor(mode)).replace(/\binc VAT\b/gi, labelFor(mode))
      );
    });
  }

  function applyAll() {
    var mode = getMode();
    document.querySelectorAll('[data-ex-vat-cents]').forEach(function (el) {
      applyElement(el, mode);
    });
    applyLabels(mode);
  }

  function syncControls() {
    var mode = getMode();
    document.querySelectorAll('[data-printem-vat-toggle]').forEach(function (root) {
      root.querySelectorAll('[data-vat-mode]').forEach(function (btn) {
        var on = btn.getAttribute('data-vat-mode') === mode;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function bindControls() {
    document.querySelectorAll('[data-printem-vat-toggle]').forEach(function (root) {
      if (root.getAttribute('data-vat-bound') === '1') return;
      root.setAttribute('data-vat-bound', '1');
      root.querySelectorAll('[data-vat-mode]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setMode(btn.getAttribute('data-vat-mode'));
        });
      });
    });
  }

  window.PrintemVat = {
    mode: getMode(),
    rate: RATE,
    getMode: getMode,
    setMode: setMode,
    applyAll: applyAll,
    formatGbpFromCents: formatGbpFromCents,
    displayCents: displayCents,
    labelFor: labelFor,
    /** Call after PDP JS updates data-ex-vat-cents */
    refresh: function () {
      applyAll();
    }
  };

  function boot() {
    document.documentElement.setAttribute('data-printem-vat', getMode());
    bindControls();
    syncControls();
    applyAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-apply after cart / product-card / section-rendering DOM swaps (morph, replaceWith). */
  var pending = false;
  function scheduleApply() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      pending = false;
      bindControls();
      syncControls();
      applyAll();
    });
  }
  function startObserver() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes' || r.addedNodes.length) {
          scheduleApply();
          return;
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-ex-vat-cents']
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  document.addEventListener('shopify:section:load', function () {
    bindControls();
    syncControls();
    applyAll();
  });
})();
